
import { ProfessionData } from '../types/professionTypes';

export const automobile: ProfessionData = {
  title: "Automobile",
  slug: "automobile",
  description: "Gestion complète des déchets de l'industrie automobile",
  icon: "Car",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Métaux ferreux et non ferreux",
      description: "Carrosserie, moteurs, pièces métalliques diverses",
      solutions: ["Démantèlement", "Tri métallique", "Revente ferrailleur"],
      environmentalBenefit: "Récupération de matières premières secondaires"
    },
    {
      type: "Fluides automobiles",
      description: "Huiles moteur, liquides de refroidissement, carburants",
      solutions: ["Collecte sélective", "Régénération", "Traitement spécialisé"],
      environmentalBenefit: "Protection des sols et des nappes phréatiques"
    },
    {
      type: "Pneumatiques",
      description: "Pneus usagés de véhicules légers et poids lourds",
      solutions: ["Collecte pneumatiques", "Rechapage", "Valorisation énergétique"],
      environmentalBenefit: "Évite l'accumulation et valorise la matière"
    },
    {
      type: "Batteries",
      description: "Batteries de démarrage, batteries hybrides/électriques",
      solutions: ["Collecte spécialisée", "Récupération plomb", "Recyclage lithium"],
      environmentalBenefit: "Récupération métaux précieux et évite la pollution"
    }
  ],
  relatedProfessions: ["garagiste", "electricien", "metallurgie"]
};
